import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import environment from "web/script/modules/environment";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import BranchLink from "web/react/components/branch-link/branch-link";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import classnames from "classnames";
import { isExcludedDesignerOnPage } from "web/react/components/webviews/financial-incentive-webviews/financial-incentive-utils";
import { FinancialIncentivesCampaignRawBranchLink } from "web/script/utils/branch-io";
import styles from "./small-app-download-banner.css";
export var BANNER_DESCRIPTIONS = {
  // "Lyst is even better in the app"
  BETTER_IN_THE_APP: gettextNoop("app_download_small_banner.better_in_the_app.description"),
  // "It's faster, personalized and at your fingertips."
  FASTER_PERSONALISED: gettextNoop("app_download_small_banner.faster_personalised.description"),
  // "Get personalized results from your favourite brands"
  SEARCH_PERSONALISATION: gettextNoop("app_download_small_banner.search_personalisation.description"),
  // "Track your favorite items and get sale alerts all in one place"
  TRACKING_SALES: gettextNoop("app_download_small_banner.tracking_sales.description")
};
var LARGE_DESCRIPTIONS = [BANNER_DESCRIPTIONS.SEARCH_PERSONALISATION, BANNER_DESCRIPTIONS.TRACKING_SALES];

function getBannerDescKey(campaignFlag) {
  var bannerDescVariant = environment.getFeature("".concat(campaignFlag, "_desc"));
  var descriptionKey = bannerDescVariant ? BANNER_DESCRIPTIONS[bannerDescVariant.toUpperCase()] : BANNER_DESCRIPTIONS.BETTER_IN_THE_APP;
  return descriptionKey;
}

function getFinancialIncentiveBannerProps() {
  var pageType = environment.get("pageType");
  var pageSubType = environment.get("pageSubType");
  var featureFlag = "";
  var branchLink = "";

  if (pageType == "homepage") {
    featureFlag = "mg_financial_incentives_homepage";
    branchLink = FinancialIncentivesCampaignRawBranchLink.Homepage;
  } else if (pageType == "feed") {
    featureFlag = "mg_financial_incentives_feed";
    branchLink = FinancialIncentivesCampaignRawBranchLink.Feed;
  } else if (pageType == "product" && pageSubType == "in_stock" && !isExcludedDesignerOnPage()) {
    featureFlag = "mg_financial_incentives_is_pdp";
    branchLink = FinancialIncentivesCampaignRawBranchLink.ISPDP;
  }

  if (featureFlag !== "" && environment.getFeature(featureFlag) !== "") {
    return {
      branchLink: branchLink,
      rewardValue: environment.getFeature("".concat(featureFlag, "_value")).toString()
    };
  }

  return null;
}

export function SmallAppDownloadBanner(_ref) {
  var bannerCampaign = _ref.bannerCampaign,
      onClose = _ref.onClose;
  // Open
  var ctaText = gettext("app_download_small_banner.general.cta");
  var bannerTitle;
  var bannerDescription;
  var isLargeDescription;
  var branchLink;
  var financialIncentivesBannerProps = getFinancialIncentiveBannerProps();

  if (financialIncentivesBannerProps && financialIncentivesBannerProps.rewardValue !== "") {
    // MG-226 - Financial Incentive Banners
    // "Get {reward_value} Back"
    bannerTitle = gettext("financial_incentive.app_download_small_banner.title", {
      reward_value: financialIncentivesBannerProps.rewardValue
    }); // Download the Lyst App and get {reward_value} back as a reward

    bannerDescription = gettext("financial_incentive.app_download_small_banner.description", {
      reward_value: financialIncentivesBannerProps.rewardValue
    });
    isLargeDescription = true;
    branchLink = financialIncentivesBannerProps.branchLink;
  } else {
    // "Get the Lyst App"
    bannerTitle = gettext("app_download_small_banner.general.title");
    var bannerDescriptionKey = getBannerDescKey(bannerCampaign.flag);
    bannerDescription = gettext(bannerDescriptionKey);
    isLargeDescription = LARGE_DESCRIPTIONS.includes(bannerDescriptionKey);
    branchLink = bannerCampaign.branchLink;
  }

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: styles.placeholder
  }), React.createElement("div", {
    className: classnames(styles.sticky, styles.downloadBanner)
  }, React.createElement("div", {
    className: styles.wrapper
  }, React.createElement(CloseButton, {
    className: styles.closeButton,
    onClick: onClose
  }), React.createElement("div", {
    className: styles.appImage
  }, React.createElement("img", {
    src: bannerCampaign.bannerImageUrl,
    alt: "Lyst App"
  })), React.createElement("div", {
    className: classnames(styles.content, _defineProperty({}, styles.largeContent, isLargeDescription))
  }, React.createElement("div", {
    className: styles.title
  }, bannerTitle), React.createElement("div", {
    className: styles.description
  }, bannerDescription)), React.createElement("div", {
    className: styles.ctaContainer
  }, React.createElement(BranchLink, {
    branchLink: branchLink,
    className: styles.cta,
    eventLabel: "app_banner_".concat(bannerCampaign.name),
    title: ctaText,
    primaryButton: true
  })))));
}
export default SmallAppDownloadBanner;